<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.9179 15.0002L12.3823 10.0002M7.62035 10.0002L2.08466 15.0002M1.66797 5.8335L8.47207 10.5964C9.02304 10.982 9.29853 11.1749 9.59819 11.2496C9.86288 11.3156 10.1397 11.3156 10.4044 11.2496C10.7041 11.1749 10.9796 10.982 11.5305 10.5964L18.3346 5.8335M5.66797 16.6668H14.3346C15.7348 16.6668 16.4348 16.6668 16.9696 16.3943C17.44 16.1547 17.8225 15.7722 18.0622 15.3018C18.3346 14.767 18.3346 14.067 18.3346 12.6668V7.3335C18.3346 5.93336 18.3346 5.2333 18.0622 4.69852C17.8225 4.22811 17.44 3.84566 16.9696 3.60598C16.4348 3.3335 15.7348 3.3335 14.3346 3.3335H5.66797C4.26784 3.3335 3.56777 3.3335 3.03299 3.60598C2.56259 3.84566 2.18014 4.22811 1.94045 4.69852C1.66797 5.2333 1.66797 5.93336 1.66797 7.3335V12.6668C1.66797 14.067 1.66797 14.767 1.94045 15.3018C2.18014 15.7722 2.56259 16.1547 3.03299 16.3943C3.56777 16.6668 4.26784 16.6668 5.66797 16.6668Z"
    stroke="currentColor"
    stroke-width="1.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
